export const STORES_LIST_FETCHED = 'STORES_LIST_FETCHED'
export const TRANSACTION_COMPLAINT_SENT = 'TRANSACTION_COMPLAINT_SENT'
export const QUERY_PARAMS_FETCHED = 'QUERY_PARAMS_FETCHED'
export const SHOPPING_HUB_FETCHED = 'SHOPPING_HUB_FETCHED'
